import React, { memo } from "react";

import {
  FlamebearerCall,
  FlamebearerMetrics
} from "@platformsh/observability-graph/ContinuousProfiling";

import * as Table from "ds/Table";
import useConprofContext from "src/organization/pages/project/environment/observabilitySandbox/experiments/Conprof/hooks/useConprofContext";

import FlamebearerTableRow from "./FlamebearerTableRow";

type Props = {
  callsMetrics: FlamebearerMetrics[];
  highlightedCall: FlamebearerCall | null;
  onCallHighlighted: (call: FlamebearerCall | null) => void;
};

const FlamebearerTableBody = ({
  callsMetrics,
  highlightedCall,
  onCallHighlighted
}: Props) => {
  const { data } = useConprofContext();
  const profileType = data?.profileType;

  if (!profileType) {
    return null;
  }

  return (
    <Table.Tbody>
      {callsMetrics.map((callMetrics: FlamebearerMetrics) => (
        <FlamebearerTableRow
          key={callMetrics.call.id}
          callMetrics={callMetrics}
          profileType={profileType}
          highlighted={
            !!(highlightedCall && highlightedCall.raw === callMetrics.call.raw)
          }
          onCallHighlighted={onCallHighlighted}
        />
      ))}
    </Table.Tbody>
  );
};

export default memo(FlamebearerTableBody);
